module.exports = __webpack_public_path__ + "static/media/icon5.c5993df9.png";